import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useEffect, useContext, useMemo } from 'react';
import { useSelector } from 'react-redux';
import useAssetActions from './useAssetActions';
import { getAssetContainer } from './assetsModule';
import { Component as AssetProvider } from './AssetProvider';
import { filterAssets } from './utils';
export default function useAsset(name) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$multi = _ref.multi,
      multi = _ref$multi === void 0 ? false : _ref$multi,
      filterFromComponent = _ref.filter,
      forceStoreGroup = _ref.forceStoreGroup,
      _ref$batchKey = _ref.batchKey,
      batchKey = _ref$batchKey === void 0 ? forceStoreGroup : _ref$batchKey;

  var actions = useAssetActions(); // Allow passing a null `name` to conditionally fetch assets. We can't bail
  // out early though due to the rules of hooks.

  var assetContainer = useSelector(state => name ? getAssetContainer(state, name) : null);
  var data = assetContainer ? assetContainer.data : null;

  var _useContext = useContext(AssetProvider.Context),
      filterFromContext = _useContext.filter;

  var filter = useMemo(() => {
    return filterFromComponent ? filterFromComponent(filterFromContext) : filterFromContext;
  }, [filterFromComponent, filterFromContext]);
  var filteredData = useMemo(() => {
    if (!data || !filter) {
      return data;
    }

    return _objectSpread(_objectSpread({}, data), {}, {
      assets: filterAssets(data.assets, filter, multi)
    });
  }, [data, filter, multi]);
  useEffect(() => {
    if (name) {
      actions.loadAssets(name, {
        forceStoreGroup,
        batchKey
      });
    }
  });
  return useMemo(() => {
    if (assetContainer) {
      return _objectSpread(_objectSpread({}, assetContainer), {}, {
        data: filteredData
      });
    }

    return null;
  }, [assetContainer, filteredData]);
}